import { useMemo } from 'react';
import { Typography } from '@mui/material';
import { ITableColumn, TableList } from 'src/components/table';
import CardActions from 'src/pages/sistema/components/CardActions';
import { useAFOPUTablaValor, AFOPURow } from '../hooks/useTablaValorAFOPU';
import { OperacionAFOPU } from '../types/types';
import { OperacionAFOPUFields, OperacionAFOPUTablaValorFields } from '../types/fields';
import { EntityWithIdFields } from 'src/types';

interface SeccionAFOPUTablaValoresProps {
  operacion: OperacionAFOPU
}

const SeccionAFOPUTablaValores = ({ operacion }: SeccionAFOPUTablaValoresProps) => {
  const { headers, rows, isLoading, isError, error } = useAFOPUTablaValor(
    operacion[EntityWithIdFields.Id]
  );

  const columns: ITableColumn[] = useMemo(() => {
    const cols: ITableColumn[] = [
      {
        label: 'Instrumento',
        onRenderCell: (row: AFOPURow) => (
          <Typography variant="body2" fontWeight="bold">
            {row.descInstrumento}
          </Typography>
        )
      }
    ];

    headers.forEach((header) => {
      cols.push({
        label: header.descOperacionTipo,
        onRenderCell: (row: AFOPURow) => {
          const celda = row.celdas[header.codOperacionTipo];

          if (!celda) return <span>-</span>;

          const valor = celda[OperacionAFOPUTablaValorFields.Valor];

          return (
            <Typography
              variant="body2"
              sx={{
                color: valor === 'No Aplica' ? 'text.disabled' : 'text.primary',
                fontStyle: valor === 'No Aplica' ? 'italic' : 'normal'
              }}
            >
              {valor}
            </Typography>
          );
        }
      });
    });

    return cols;
  }, [headers]);

  return (
    <CardActions title='Tabla de Valores' icon='mdi:table-check' colapsable tableContent>
      <TableList
        entityList={rows}
        columns={columns}
        isLoading={isLoading}
        error={isError ? error?.message : false}
      />
    </CardActions>
  );
};

export default SeccionAFOPUTablaValores;
